import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { LayoutGrid } from 'lucide-react'
import { CaseCard } from './CaseCard'
import { StatusTabButton } from './CaseManagementDashboard.parts'
import type { useCaseDashboard } from './use-case-management-dashboard'

type Dash = ReturnType<typeof useCaseDashboard>

interface CaseWorkViewProps {
  dash: Dash
  onOpenCase: ((caseId: string) => void) | undefined
}

export function CaseWorkView({ dash, onOpenCase }: CaseWorkViewProps): ReactElement {
  const { t } = useTranslation(['cases', 'common'])
  return (
    <div className="p-6">
      <div className="mb-6 flex gap-1 border-b" style={{ borderColor: 'var(--border)' }}>
        <StatusTabButton
          tab="active"
          activeTab={dash.statusTab}
          label={t('management.activeTab')}
          count={dash.tabCounts.active}
          onSelect={dash.setStatusTab}
        />
        <StatusTabButton
          tab="closed"
          activeTab={dash.statusTab}
          label={t('management.closedTab')}
          count={dash.tabCounts.closed}
          onSelect={dash.setStatusTab}
        />
        <StatusTabButton
          tab="archived"
          activeTab={dash.statusTab}
          label={t('management.archivedTab')}
          count={dash.tabCounts.archived}
          onSelect={dash.setStatusTab}
        />
      </div>
      {dash.filteredCases.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-16 text-center">
          <div
            className="mb-4 flex h-16 w-16 items-center justify-center rounded-full"
            style={{ background: 'var(--highlight)' }}
          >
            <LayoutGrid className="h-8 w-8" style={{ color: 'var(--text-muted)' }} />
          </div>
          <p style={{ color: 'var(--text-muted)' }}>
            {dash.searchQuery
              ? t('management.noCasesMatching', { tab: dash.statusTab })
              : t('management.noCases', { tab: dash.statusTab })}
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">
          {dash.filteredCases.map((caseItem) => (
            <CaseCard
              key={caseItem.id}
              caseData={caseItem}
              onClick={() => {
                ;(onOpenCase ?? dash.handleOpenCase)(caseItem.id)
              }}
            />
          ))}
        </div>
      )}
    </div>
  )
}
